import EventEmitter from 'owa-event-emitter';

export const campaignEventEmitter = new EventEmitter();
export const ARC_API_CALL_COMPLETED = 'ARC_API_CALL_COMPLETED_{0}'; // {0} is placement Id
